export const Netinfo = {
	fetch: () =>
		Promise.resolve({
			isInternetReachable: true,
		}),
};
